import { render, staticRenderFns } from "./calendarDiscounts.vue?vue&type=template&id=06cddb49&scoped=true&"
import script from "./calendarDiscounts.vue?vue&type=script&lang=js&"
export * from "./calendarDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./calendarDiscounts.vue?vue&type=style&index=0&id=06cddb49&lang=less&scoped=true&"
import style1 from "./calendarDiscounts.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cddb49",
  null
  
)

export default component.exports